import { all } from "redux-saga/effects"
import update from "./update"
import calendarUpdate from "./calendarUpdate"
import transition from "./transition"
import allStatuses from "./allStatuses"

export default function* statusSaga() {
  while (true) {
    yield all({
      update: update(),
      calendarUpdate: calendarUpdate(),
      transition: transition(),
      allStatuses: allStatuses(),
    })
  }
}
